import PropTypes from "prop-types";

import { Grid, Paper, Typography } from "@mui/material";

import { formatDate, formatNumber } from "@/features/shared";

export const BalanceInformationSection = ({ chartOfAccount }) => {
  const initialBalance = chartOfAccount.initialBalanceTransaction?.amount;
  const effectiveDate = chartOfAccount.initialBalanceTransaction?.transactionDate;
  const currentBalance = chartOfAccount.totalBalance || 0;

  // Build label for initial balance with date
  const initialBalanceLabel = effectiveDate
    ? `Saldo Awal (${formatDate(effectiveDate)})`
    : "Saldo Awal";

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Saldo
      </Typography>
      <Grid container spacing={3}>
        {/* Saldo Sekarang */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            Saldo Sekarang
          </Typography>
          <Typography variant="body1" sx={{
            fontWeight: "bold"
          }}>
            Rp {formatNumber(currentBalance)}
          </Typography>
        </Grid>

        {/* Saldo Awal (with date if exists) */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="body2" gutterBottom sx={{
            color: "text.secondary"
          }}>
            {initialBalanceLabel}
          </Typography>
          <Typography variant="body1">
            {initialBalance != null
              ? `Rp ${formatNumber(initialBalance)}`
              : "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

BalanceInformationSection.propTypes = {
  chartOfAccount: PropTypes.object.isRequired,
};
